import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-estornos-edit',
  templateUrl: './estornos-edit.component.html',
  standalone: false
})
export class EstornosEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/estornos`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Estornos', link: '/estornos' }, { label: 'Edi\u00e7\u00e3o Estornos' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'estornos',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('estornos').subscribe(data => {
        this.fields = data;
    });
  }

}
